var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-list" },
    [
      _vm._l(_vm.feedbacks, function(feedback) {
        return _c("feedback-list-entry", {
          key: feedback.id,
          attrs: {
            feedback: feedback,
            "is-reply": false,
            "show-controls": _vm.showControls,
            classes: _vm.classes,
            styles: _vm.styles,
            options: _vm.options
          },
          on: {
            delete: function($event) {
              return _vm.$emit("delete", $event)
            }
          }
        })
      }),
      _vm._v(" "),
      !_vm.isLastPage
        ? _c(
            "a",
            {
              staticClass:
                "btn btn-success text-white btn-block mb-3 feedback-loadmore",
              on: {
                click: function($event) {
                  return _vm.onLoadMoreClicked()
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$translate("Feedback::Feedback.loadMore")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNotFirstPage
        ? _c(
            "a",
            {
              staticClass: "btn btn-link btn-block feedback-showless",
              attrs: { href: "#feedbackContainer" },
              on: {
                click: function($event) {
                  return _vm.$emit("load-page", 1)
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$translate("Feedback::Feedback.showLess")) +
                  "\n  "
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }